import { tWithKeyAttr as t } from "./i18nHelper";
import { createRoot, Root } from "react-dom/client";
import { Provider } from "react-redux";
import i18n from "./i18n";
import AdminTextEditor from "./components/adminTextEditor/adminTextEditor";
import store from "./services/store";

let root: Root | null = null;

export function enableTranslationMode(isEnabled: boolean) {
  if (isEnabled) {
    document.body.style.cursor = "pointer";
    document.addEventListener("dblclick", handleDoubleClick);
  } else {
    document.body.style.cursor = "";
    document.removeEventListener("dblclick", handleDoubleClick);

    const container = document.getElementById("react-popup-root");
    if (container) {
      if (root) {
        root.unmount();
        root = null;
      }
      container.remove();
    }
  }
}

function handleDoubleClick(e: MouseEvent) {
  const el = e.target as HTMLElement;
  const key = el.getAttribute("data-i18n-key");
  if (!key) return;

  const text = el.innerText.trim();

  // אם כבר יש פופאפ פתוח – נסגור ונפתח חדש
  const existing = document.getElementById("react-popup-root");
  if (existing) {
    if (root) {
      root.unmount();
      root = null;
    }
    existing.remove();
  }

  const container = document.createElement("div");
  container.id = "react-popup-root";
  document.body.appendChild(container);

  try {
    root = createRoot(container);
    root.render(
      <Provider store={store}>
        <AdminTextEditor
          translationKey={key}
          text={text}
          onClose={() => {
            const container = document.getElementById("react-popup-root");
            if (root) {
              root.unmount();
              root = null;
            }
            container?.remove();
          }}
        />
      </Provider>
    );
  } catch (err) {
    console.error(t('ERROR_OPENING_POPUP'), err);
  }
}

export const addKeysToAllTranslatedElements = () => {
  const keys = Object.keys(i18n.store.data[i18n.language]?.translation || {});
  keys.forEach((key) => {
    const translated = i18n.t(key).trim();

    const existing = document.querySelectorAll(`[data-i18n-key="${key}"]`);
    if (existing.length > 0) return;

    const allElements = document.querySelectorAll("body *");
    allElements.forEach((el) => {
      const elText = (el.textContent || "").trim();
      if (elText === translated) {
        el.setAttribute("data-i18n-key", key);
      }
    });
  });
};
